'use client';

import type { Ref } from 'react';

import classnames from 'classnames';

import type { BadgeProps } from './Badge.types';

import styles from './Badge.module.scss';

export function Badge({
  style,
  className,
  bg = 'neutral',
  children,
  testId = 'ui-badge',
  ref,
  ...rest
}: BadgeProps & { ref?: Ref<HTMLDivElement> }) {
  return (
    <div
      ref={ref}
      style={style}
      className={classnames(
        styles['badge'],
        bg && styles[`badge--${bg}`],
        className,
      )}
      data-testid={testId}
      {...rest}
    >
      {children}
    </div>
  );
}
